const FeedbackTypes = {
    Positive: 'positive',
    Neutral: 'neutral',
} as const;

export default FeedbackTypes;
